<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.userInfo.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('p1')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('phone')">
                                <el-input v-model="searchform.blurry" style="width: 200px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('p2')}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="content" :label="$t('p3')" style="width:500px" ></el-table-column>
                        <el-table-column prop="recipient" :label="$t('p4')"></el-table-column>
                        <el-table-column prop="channel" :label="$t('p5')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.channel == 1" type="info">{{$t('p6')}}</el-tag>
                                <el-tag v-if="scope.row.channel == 2" type="info">{{$t('p7')}}</el-tag>
                                <el-tag v-if="scope.row.channel == 3" type="info">{{$t('p8')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platform" :label="$t('p9')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.platform == 1" type="info">Mcash</el-tag>
                                <el-tag v-if="scope.row.platform == 2" type="info">SuPrestamo</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up title='信息推送' :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" style="width: 400px;">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('p10')" prop="tempId">
                        <el-select size="small" v-model="form.tempId" :placeholder="$t('qxz')" style="width:200px;" @change="fillCon">
                            <el-option v-for="item in plantList" 
                            :key="item.id"
                            :label="item.tempId"
                            :value="item.tempId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item :label="$t('p11')" prop="content">
                        <el-input type="textarea" v-model="form.content" />
                    </el-form-item> -->
                    <el-form-item :label="$t('p12')" prop="channel">
                        <el-radio-group v-model="form.channel">
                            <el-radio :label="1">{{$t('p6')}}</el-radio>
                            <el-radio :label="2">{{$t('p7')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('p13')" prop="platform">
                        <el-select v-model="form.platform" placeholder="请选择">
                            <el-option label="Mcash" value="1"></el-option>
                            <el-option label="SuPrestamo" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="接收人：" prop="recipient" >
                        <el-input v-model="form.recipient" />
                    </el-form-item> -->
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    content: null,
                    recipient: null,
                    channel: null,
                    platform: null,
                    tempId: null,
                },
                rules:{
                    content:[{ required: true, trigger: 'blur' },],
                    recipient:[{ required: true, trigger: 'blur' },],
                    channel:[{ required: true, trigger: 'blur' },],
                    platform:[{ required: true, trigger: 'blur' },],
                    tempId:[{ required: true, trigger: 'blur' },],
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                plantList:[],
                total: 1,
                pageNo: 1,
                pageSize: 10,
            }
        },
        created() {
            this.userInfo=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getplantList()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    content: null,
                    recipient: null,
                    channel: null,
                    platform: null,
                    tempId: null,
                }
            },
            fillCon(e) {
                this.form.content = e
            },
            getplantList() {
                _api.get(apiurl.plantilla, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.plantList = res.data
                })
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            getconfirm() {
                _api.post(apiurl.pushinfo, this.form).then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('addSuccess')
                    })
                    this.getList()
                    this.showadd = false
                    this.form = {
                        id: null,
                        content: null,
                        recipient: null,
                        channel: null,
                        platform: null,
                        tempId: null,
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            getList() {
                this.loading = true
                _api.get(apiurl.pushinfo, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry,
                }).then(res => {
                    this.loading = false
                    this.blurry= null
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>